import { Stack, Typography } from "@mui/material";
import { useQuery } from "react-query";
import API from "../../services/API";
import Card from "../Courses/Card";

export function Masterclass() {
    const { data: courses } = useQuery({
        queryKey: ['masterclass', 'dentaire'],
        queryFn: async () => {
            const { data } = await API.get('/courses');
            return data.filter((c) => 
                c.kind?.id === 'masterclass' && c.category?.id === 'dentaire'
            );
        }
    });

    if (!courses || courses?.length === 0) return <></>;

    return (
        <Stack gap={2}>
            <Typography variant="h1">Nos MasterClass</Typography>
            <Stack direction="row" flexWrap="wrap">
                {courses.map((course) => <Card key={course.id} course={course} />)}
            </Stack>
        </Stack>
    );
}